const css = require('./styles.css');
const request = require('./lib/request');

const gapTpl = gap => `<div style="background: ${gap.color}" class="${css.gap__overlay}"></div>
<a class="${css.link} ${css.gap__link}" href="${gap.url}">${gap.name} ${gap.time}</a>`;

const locationTpl = user => {
    const place = user.table ?
        `<a class="${css.link}" href="${user.table.url}">${user.office}</a>` :
        `<span>${user.office}</span>`;

    const visit = user.last_office ?
        `<span class="${css.visit}"> — ${user.last_office.office}, ${user.last_office.ago}</span>` :
        '';

    return `${place} ${visit}`;
};


const emailButtonTpl = user =>
    `<button class="${css.button} ${css.button_jabber} ${css['button_status_' + (user.is_dismissed ? 'none' : user.jabber_status)]}">${user.work_email.replace(/yandex-team\.ru$/, '')}</button>`;

const contactsTpl = (user, width) => `<div class="${css.contact}" style="width: ${width}px">
    <div class="${css.contact__row}">
        <span class="${css.contact__reset} ${css.link}">↺</span>
        <input class="${css.input}" type="text" value="${user.work_email}" />
    </div>
    <a class="${css.link} ${css.contact__link}" href="mailto:${user.work_email}">Write email</a>
    <a class="${css.link} ${css.contact__link}" href="xmpp:${user.work_email}">Write to jabber</a>
</div>`;

const userBodyTpl = (user, options) => `
    <div><a class="${css.link} ${css.link_type_user}" href="//staff.yandex-team.ru/${user.login}" target="${options.target}">${user.first_name} ${user.last_name}</a></div>
    <div>${user.position}</div>
    <div class="${css.contacts}">
        ${emailButtonTpl(user)}
        ${(user.phones && user.phones.work) ? `<button class="${css.button} ${css.button_phone}">${user.phones.work}</button>` : ''}
    </div>
    <div class="${css.contacts}">
        ${(user.phones && user.phones.mobile) ? `<button class="${css.button} ${css.button_phone}">${user.phones.mobile}</button>` : ''}
    </div>
`;

module.exports = class UserInfo {
    constructor(container, user, options = {}) {
        container.querySelector(`.${css.head}`).textContent = user.dep.name;
        container.querySelector(`.${css.avatar}`).innerHTML = `<img src="${user.avatar}">`;
        container.querySelector(`.${css.body}`).innerHTML = userBodyTpl(user, options);

        if (user.is_dismissed) {
            const location = container.querySelector(`.${css.location}`);
            location.parentNode.removeChild(location);
        } else {
            const location = container.querySelector(`.${css.location}`);
            location.classList.add(css.location_loaded);
            location.innerHTML = locationTpl(user);
        }

        if (user.gap) {
            const gapElement = document.createElement('div');
            gapElement.innerHTML = gapTpl(user.gap);
            gapElement.classList.add(css.gap);
            container.appendChild(gapElement);
        }

        addChildEventListener(container, 'click', `.${css.button_jabber}`, () => {
            const button = container.querySelector(`.${css.button_jabber}`);
            button.outerHTML = contactsTpl(user, button.offsetWidth);
            container.querySelector(`.${css.input}`).select();
        });
        addChildEventListener(container, 'click', `.${css.contact__reset}`, () => {
            container.querySelector(`.${css.contact}`).outerHTML = emailButtonTpl(user);
        });
        addChildEventListener(container, 'click', `.${css.button_phone}`, button => this.callPhone(button));
    }

    callPhone(button) {
        function onFinish() {
            pendingTasks--;
            if (pendingTasks === 0) {
                button.classList.remove(css.button_calling);
            }
        }

        const number = button.textContent;
        let pendingTasks = 2;
        button.classList.add(css.button_calling);
        setTimeout(onFinish, 1000);

        request.getJSON(`//staff.yandex-team.ru/api/call/${number}?format=json`)
            .then(onFinish)
            .catch(onFinish);
    }
};

function addChildEventListener(parent, eventType, childSelector, handler) {
    parent.addEventListener(eventType, function(event) {
        const child = event.target.closest(childSelector);

        if (child) {
            handler(child);
        }
      });
}



// WEBPACK FOOTER //
// ./src/user-info.js